export const GET_LOGIN_PAGE_LOGO = 'GET_LOGIN_PAGE_LOGO';
export const SET_LOGIN_PAGE_LOGO = 'SET_LOGIN_PAGE_LOGO';
export const GET_IDENTITY_PROVIDERS = 'GET_IDENTITY_PROVIDERS';
export const SET_IDENTITY_PROVIDERS = 'SET_IDENTITY_PROVIDERS';
export const RECOVER_PASSWORD = 'RECOVER_PASSWORD';
export const DO_STANDARD_LOGIN = 'DO_STANDARD_LOGIN';
export const DO_SSO_LOGIN = 'DO_SSO_LOGIN';
export const SET_STANDARD_LOGIN_ERROR = 'SET_STANDARD_LOGIN_ERROR';
export const SET_SSO_LOGIN_ERROR = 'SET_SSO_LOGIN_ERROR';
export const GET_SSO_LOGIN_ERROR = 'GET_SSO_LOGIN_ERROR';
export const SET_ACTIVE_DIALOG = 'SET_ACTIVE_DIALOG';
export const GET_APPETIZE_PREF = 'GET_APPETIZE_PREF';
export const SET_APPETIZE_CONFIG = 'SET_APPETIZE_CONFIG';
